/**
 * Mixpanel project IDs for tracking analytics across Watershed applications.
 *
 * Dashboard and Learning Hub (docs site) use the same Mixpanel project to enable
 * unified session replays and funnel analysis across both applications.
 */
export const PRODUCTION_MIXPANEL_PROJECT_ID =
  'ea14cd223be763ce1b8b6894b0a8e725';

/**
 * Track development events to a separate project for easier debugging.
 */
export const DEV_MIXPANEL_PROJECT_ID = '8c7027f56f03bd885ed39ecf7de8ef28';

/**
 * Admin app uses a separate Mixpanel project due to different event schema
 * and user properties (tracks Watershed employees rather than customers).
 */
export const ADMIN_MIXPANEL_PROJECT_ID = 'beda7316030228f11a5fbc7e14a8abe2';
